module.exports = __webpack_public_path__ + "kaitak_image_support_01.0e3e01ad3f1f79f3e1e5.png";